const blinkIconWhite = `<span class='blink-indicator blink-indicator--white'><span></span></span>`
export default blinkIconWhite